import { TapResponse } from '@iotize/tap';
import { StringConverter, TlvBundleConverter } from '@iotize/tap/client/impl';

import { VariableMeta } from '../generated/models';
import { VariableService } from '../generated/service';

const utf8Converter = new StringConverter('utf8');

declare module '../generated/service' {
  export interface VariableService {
    // getMetaData(id: number): Promise<TapResponse<Uint8Array>>;
    // putMetaData(
    //     id: number,
    //     data: Uint8Array
    // ): Promise<TapResponse<void>>;
    getAllValues(): Promise<TapResponse<Record<number, Uint8Array>>>;
  }
}

VariableService.prototype.getMeta = function (
  this: VariableService,
  id: number,
): Promise<TapResponse<VariableMeta>> {
  return this.getRawMeta(id).then((response) => {
    const metaResponse =
      response as TapResponse<unknown> as TapResponse<VariableMeta>;
    metaResponse.setBodyDecoder({
      decode: (raw: Uint8Array) => {
        const [name, ...extra] = utf8Converter.decode(raw).split(':');
        return {
          name,
          unit: extra.length > 0 ? extra[0] : '',
        };
      },
    });
    return metaResponse;
  });
};

VariableService.prototype.putMeta = function (
  this: VariableService,
  id: number,
  data: VariableMeta,
): Promise<TapResponse<void>> {
  const encoded = utf8Converter.encode(`${data.name}:${data.unit}`);
  return this.putRawMeta(id, encoded);
};

VariableService.prototype.getAllValues = function (
  this: VariableService,
): Promise<TapResponse<Record<number, Uint8Array>>> {
  return this.readProfile().then((responseInterface) => {
    const response: TapResponse<Record<number, Uint8Array>> =
      responseInterface as any;
    if (response.isSuccessful()) {
      const data = response.rawBody();
      const converter = new TlvBundleConverter<Record<number, Uint8Array>>();
      const mappings = converter.decode(data);
      response.setBody(mappings);
    }
    return response;
  });
};
